import { IProgramSetup } from 'shared/interfaces/IProgramSetup';
import { ConflictListWrap, ConflictRow, Hint, MiniButton } from './ProgramSetupSchedule.styled';
import { DAY_NAMES, fmtRange, isSimulcast, nameOf, OverlapPair, ScheduleMode, slotOf } from './scheduleUtils';

interface Props {
  mode: ScheduleMode;
  records: IProgramSetup[];
  pairs: OverlapPair[];
  onEdit: (id: string) => void;
}

export const ConflictList = ({ mode, records, pairs, onEdit }: Props) => {
  const label = mode === 'tv' ? 'channel' : 'station';
  const simCount = records.filter((record) => isSimulcast(record, mode)).length;
  const range = (record: IProgramSetup, day: number) => {
    const slot = slotOf(record, day);
    return slot ? fmtRange(slot).replace(' – ', '–') : '';
  };

  return (
    <>
      {pairs.length > 0 && (
        <ConflictListWrap>
          {pairs.map(({ day, a, b }) => (
            <ConflictRow key={`${day}|${a._id}|${b._id}`}>
              <span className="d">{DAY_NAMES[day].slice(0, 3).toUpperCase()}</span>
              <span className="t">
                <b>{nameOf(a, mode)}</b> {range(a, day)} overlaps <b>{nameOf(b, mode)}</b> {range(b, day)}
              </span>
              <MiniButton type="button" onClick={() => onEdit(a._id)}>
                Open {nameOf(a, mode)}
              </MiniButton>
              <MiniButton type="button" onClick={() => onEdit(b._id)}>
                Open {nameOf(b, mode)}
              </MiniButton>
            </ConflictRow>
          ))}
        </ConflictListWrap>
      )}
      {simCount > 0 && (
        <Hint>
          {simCount} program{simCount === 1 ? ` on this ${label} is` : `s on this ${label} are`} flagged as simulcast.
          The same programme on another {label} is not a conflict and is never counted here.
        </Hint>
      )}
    </>
  );
};
